import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 18l18 -12h-18l9 14l9 -14v10l-18 -10l0 12","key":"svg-0"}]]

/**
 * IconBrandDcos
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZGNvcyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyAxOGwxOCAtMTJoLTE4bDkgMTRsOSAtMTR2MTBsLTE4IC0xMGwwIDEyIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-dcos
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandDcos = createReactComponent('outline', 'brand-dcos', 'BrandDcos', __iconNode);

export default IconBrandDcos;